import React from 'react';

import { BackArrow } from 'components/navigation/back-arrow';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';

import { ProductDetailBackArrowContainer } from './styled';
import { IProductDetailBackArrow } from './types';

export const ProductDetailBackArrow: React.FC<IProductDetailBackArrow> = ({
  onPress,
  eventAttributes = {},
}) => {
  const handlePress = () => {
    // Leaving goBack fow now, there will be new logic to handle this action based on each flow.
    onPress();

    logButtonClick({
      attributes: {
        ...eventAttributes,
        name: eventAttributes?.name ?? '',
        component: ClickEventComponentNames.PRODUCT_DETAIL_BACK_NAVIGATION,
      },
    });
  };

  return (
    <ProductDetailBackArrowContainer>
      <BackArrow onPress={handlePress} />
    </ProductDetailBackArrowContainer>
  );
};
